import {faFileCode} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import KeyValueStore from "orbit-db-kvstore"
import React, {useCallback, useContext, useEffect, useState} from "react"
import {Link} from "react-router-dom"
import {NoReposContainer} from "../../components/Repo/NoReposContainer"
import {WithReposContainer} from "../../components/Repo/WithReposContainer"
import {ProfileContext} from "../../context/Profile.context"
import {RepoMeta} from "../../interfaces/repos"
import styles from "./index.module.scss"

export const Repos = () => {
  const {profile, profileReplCnt} = useContext(ProfileContext)
  const [repos, setRepos] = useState<RepoMeta[]>()

  const parseRepos = useCallback(async (profile: KeyValueStore<any>) => {
    await profile.load()
    const fields = profile.all

    const reposMap: RepoMeta[] = Object.keys(fields)
      .filter(key => key.startsWith("repo_"))
      .map(key => fields[key])
      .filter(repo => repo.id != null)

    const repos: RepoMeta[] = []
    for (const key in reposMap) {
      const repo = reposMap[key]
      repos.push({
        name: repo.name,
        description: repo.description,
        address: repo.address,
        createAt: repo.createAt
      })
    }
    setRepos(
      repos
        .filter(repo => repo.address != null)
        .sort((a, b) => {
          return b.createAt - a.createAt
        })
    )
  }, [])

  useEffect(() => {
    if (!profile) {
      return
    }
    parseRepos(profile).then()
  }, [profile, parseRepos, profileReplCnt])

  if (!profile) {
    return null
  }

  return (
    <div className={styles.Container}>

      <div className={styles.Header}>
        <FontAwesomeIcon icon={faFileCode} className={styles.HeaderIcon}/>
        <div className={styles.HeaderText}>Your Repositories</div>

        <Link className={styles.CreateButton}
              to={"./new"}
        >
          Create New Repo
        </Link>
      </div>

      {
        repos === undefined
          ? null
          : repos.length === 0
            ? <NoReposContainer/>
            : <WithReposContainer profile={profile} repos={repos}/>
      }
    </div>
  )
}
